import { EXPERIMENT_SETTINGS_PROCESSING_CONFIG_LOADED } from '../../../actionTypes/experimentSettings';
var loadedProcessingConfig = function loadedProcessingConfig(processingConfig) {
  var fromGem2s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    dispatch({
      type: EXPERIMENT_SETTINGS_PROCESSING_CONFIG_LOADED,
      payload: {
        data: processingConfig,
        fromGem2s: fromGem2s
      }
    });
  };
};
export default loadedProcessingConfig;